<template>
  <v-app>
    <component :is="layout" />

    <helper-maintenance-mode :show-dialog="maintenanceDialog" />
    <!-- <helper-add-phone
      v-if="phoneDialog"
      :show-dialog="phoneDialog"
      :mandatory="true"
      @closePhoneDialog="closePhoneDialog"
    /> -->
    <helper-version-dialog
      :show-dialog="versionDialog"
      :version="appState"
    />
    <!-- <plan-wizard 
      v-if="planWizardDialog"
      :show-dialog="planWizardDialog"
      @closePlanWizardDialog="closePlanWizardDialog"
    /> -->

    <helper-notification />
    <helper-permission-dialog />
  </v-app>
</template>
<script>
const APP_STATE_QUERY = require("@/graphql/queries/AppState.gql");

import { mapMutations, mapState, mapGetters } from "vuex";
import { Quill } from "vue2-editor";
import ImageResize from 'quill-image-resize-vue';
import { ImageDrop } from 'quill-image-drop-module';
import { checkQuizNeeded } from "@/utils/quizCheck";

Quill.register('modules/imageDrop', ImageDrop);
Quill.register("modules/imageResize", ImageResize);


export default {
  data: () => ({
    // phoneDialog: false,
    // planWizardDialog: false,
    maintenanceDialog: false,
    versionDialog: false,
  }),
  metaInfo() {
    return {
      title: this.$ls.get("config").name,
    };
  },
  computed: {
    ...mapState("app", ["version"]),
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("app", ["getIsLoggedIn"]),
    layout() {
      if (this.$route.name !== null) {
        return "core-" + this.$route.meta.layout;
      }
      return null;
    },
  },
  mounted() {
    this.setVersion(require("../package.json").version);
    this.$moment.locale(this.$i18n.locale);
    localStorage.setItem("page_reloaded", false);

    const isLoggedIn =
      localStorage.getItem("auth-token") != null ? true : false;
    this.setIsLoggedIn(isLoggedIn);
    this.fixAutoFills();
    
    // Проверяем квиз только при загрузке приложения
    const authToken = localStorage.getItem("auth-token");
    if (authToken) {
      this.$nextTick(() => {
        this.checkQuizAndRedirect();
      });
    }
  },

  methods: {
    ...mapMutations("app", ["setVersion", "setAppState", "setIsLoggedIn"]),
    fixAutoFills() {
      setTimeout(() => {
        const els = document.querySelectorAll("input:-webkit-autofill");
        els.forEach((el) => {
          const label = el.parentElement.querySelector("label");
          label.classList.add("v-label--active");
        });
      }, 1000);
    },
    async checkQuizAndRedirect() {
      const authToken = localStorage.getItem("auth-token");
      // Проверяем только при инициализации и только для dashboard
      if (authToken && this.$route.name === "Dashboard") {
        try {
          const { needed, redirect } = await checkQuizNeeded();
          if (needed && redirect === null) {
            this.$router.push("/quiz");
          }
        } catch (error) {
          console.error('Error checking quiz in App.vue:', error);
        }
      }
    },
  },
  apollo: {
    appState: {
      query: APP_STATE_QUERY,
      variables: {
        app_name: "aum-expert-admin",
      },
      fetchPolicy: "network",
      pollInterval: 30 * 1000,
      result({ loading, data: { appState } }) {
        if (!loading && appState != undefined) {
          this.setAppState(appState);
          // if (this.version !== appState.version) {
          //   this.versionDialog = true;
          // }
          if (appState.status !== "live") {
            this.maintenanceDialog = true;
          } else {
            this.maintenanceDialog = false;
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
@use "@/styles/index.scss";
</style>
